module.exports = __webpack_public_path__ + "img/TPV-L1-6-Pagina7 A.b2428fab.png";